import { config } from '@/config';
import { request } from '@/utils';

export const getLead = async requestData => {
  const response = await request({
    method: 'post',
    url: `${config.amoApiRoot}/api/v3/leads`,
    data: JSON.stringify({
      ...requestData,
    }),
    auth: config.amoBasicAuth,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};

export const updateLead = async data => {
  await request(
    {
      method: 'post',
      url: `${config.amoApiRoot}/api/v3/update/lead`,
      data: JSON.stringify(data),
      auth: config.amoBasicAuth,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    false
  );

  return null;
};

export const sendNote = async data => {
  await request(
    {
      method: 'post',
      url: `${config.amoApiRoot}/api/v3/notes/add`,
      data: JSON.stringify(data),
      auth: config.amoBasicAuth,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    false
  );

  return null;
};

export const createNote = async (req, res) => {
  try {
    const { crmLeadId, dgoCrmLeadId } = req.params;
    const { noteId, errorMessage } = req.body;

    const generateNoteMessage = (id, errorMsg) => {
      switch (id) {
        case 'lead-data-error':
          return `⚠️ Возникла ошибка при получении даных лида::\n'message': ${errorMsg}`;
        case 'payment-error':
          return `⚠️ Возникла ошибка при получении ссылки оплаты:\n'message': ${errorMsg}`;
        default:
          return '';
      }
    };

    const noteData = {
      lead_id: Number(crmLeadId),
      note: generateNoteMessage(noteId, errorMessage),
      error: true,
    };

    await sendNote(noteData);

    if (dgoCrmLeadId) {
      await sendNote({ ...noteData, lead_id: Number(dgoCrmLeadId) });
    }

    return res.status(200).end();
  } catch (error) {
    const { status, statusText, message } = error.response || {};
    return res.status(status).send({ error: message || statusText });
  }
};
